import React from 'react';
//import Conexion from './../conexion/conexion';
import Header from '../elementos/basicos/Header';
import Boton from '../elementos/eventos/Boton';

import Footer from '../elementos/basicos/Footer';
import styled from 'styled-components';


//Este objeto ará referencia a que en caso de error nos salga un error diciendonos que ha habido un error
const AvisoLegal = () => {

    return (
        <>
            <Header />
            <Container404>
                <Texto1>Oops! No se ha encontrado la página a la que intentas acceder</Texto1>
                <Texto2>La página que estas visitando ya no esta disponible, ha sido cambiada o eliminada</Texto2>
                <Error>404</Error>
                <Boton to="/">Ir a Inicio</Boton>

            </Container404>
            <Footer />

        </>
    );
}


const Container404 = styled.div`
    text-align: center;
    margin-top: 100px;
    font-family: 'Roboto';
    

    
`

const Texto1 = styled.p`
    font-size: 22px;
    color: #7A7A7A;

`

const Texto2 = styled.p`
    font-size: 16px;
    line-height: 1.8;
    color: #4a4a4a;
    overflow-wrap: break-word;

`

const Error = styled.h2`
    font-weight: 700;
    font-size: 200px;
    margin: 40px 0;
    font-family: 'Dosis';
    color: #EE805D;

`


export default AvisoLegal;
